/* global history */
import _ from 'lodash';
import azureSearch from '@frontisbv/scheffer-azuresearch-searchclient';
import helper from '../../util/helper';
import Vue from 'vue';

function init(elId) {
    new Vue({
        el: '#' + elId,
        data() {
            return {
                checkedFacets: [],
                count: 0,
                currentPage: 1,
                facetOptions: [],
                facets: [],
                facetSettings: {},
                facetValueOverrides: [],
                filtered: false,
                hasError: true,
                initialSearch: true,
                items: [],
                localStorageName: 'sabaLocal',
                noResults: false,
                paginatorSettings: {
                    maxPagesPerRange: 3
                },
                ready: false,
                restoreFromStorage: false,
                searchApi: null,
                searchSettings: {},
                searchText: '',
                seoSettings: {},
                tempRestorePage: 1,
                showDrawer: false,
                ctaSettings: {}
            };
        },
        computed: {
            currentRange() {
                return this.pageRanges[this.currentRangeIndex];
            },
            currentRangeIndex() {
                for (var i = 0; i < this.numberOfRanges; i++) {
                    var range = this.pageRanges[i];
                    for (var j = 0; j < range.length; j++) {
                        if (range[j] === this.currentPage) return i;
                    }
                }
            },
            nextRange() {
                if (this.currentRangeIndex < this.numberOfRanges) return this.pageRanges[this.currentRangeIndex + 1];
            },
            numberOfPages() {
                return Math.ceil(this.count / this.searchSettings.searchRequest.top);
            },
            numberOfRanges() {
                return Math.ceil(this.numberOfPages / this.paginatorSettings.maxPagesPerRange);
            },
            orderedFacets() {
                for (var key in this.facets) {
                    if (this.facets.hasOwnProperty(key) && key.indexOf('@odata') === -1) {
                        var facet = this.facets[key];
                        if (facet) {
                            this.facets[key].sort();
                        }
                    }
                }
                return this.facets;
            },
            pageRanges() {
                const ranges = [];
                for (let i = 0; i < this.numberOfRanges; i++) {
                    var range = [];
                    for (let j = 1; j <= this.paginatorSettings.maxPagesPerRange; j++) {
                        let page = i * this.paginatorSettings.maxPagesPerRange + j;
                        if (page <= this.numberOfPages) range.push(page);
                    }
                    ranges.push(range);
                }
                return ranges;
            },
            previousRange() {
                if (this.currentRangeIndex > 0) return this.pageRanges[this.currentRangeIndex - 1];
            }
        },
        watch: {
            checkedFacets(val) {
                this.currentPage = 1;
                this.search()
                    .then((res) => {
                        if (this.restoreFromStorage) {
                            this.currentPage = this.tempRestorePage;
                            this.search()
                                .then((secondResponse) => {
                                    this.tempRestorePage = 1;
                                    this.restoreFromStorage = false;
                                })
                                .catch((secondError) => { console.error(secondError); });
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    });
            },
            restoreFromStorage(val) {
                if (!val) this.ready = true;
            }
        },
        methods: {
            toggleDrawer() {
                this.showDrawer = !this.showDrawer;
            },
            activeFacetsCount(facets) {
                if (facets.length > 0) {
                    return facets.filter((f) => f.count > 0).length;
                }
                return 0;
            },
            createSearchRequest() {
                const searchRequest = new azureSearch.AzureSearchRequest(this.searchSettings.searchRequest);
                const predefinedFilter = this.searchSettings.searchRequest.filter;
                const facetFilters = this.initialSearch ? null : GetFacetFilter(this.checkedFacets, this.facetSettings);

                this.searchSettings.searchRequest.skip = searchRequest.skip = (this.currentPage - 1) * this.searchSettings.searchRequest.top;
                searchRequest.filter = ConcatFilters([predefinedFilter, facetFilters]);
                return searchRequest;
            },
            executeSearch(searchRequest) {
                const self = this;

                return new Promise((resolve, reject) => {
                    self.searchApi.search(searchRequest)
                        .then((res) => {
                            self.noResults = false;

                            if (res && res.data) {
                                self.items = res.data.value;
                                if (this.ctaSettings.ctaVisible) {
                                    if (self.items.length < 5) self.items.push(this.ctaSettings);
                                    else self.items.splice(4, 0, this.ctaSettings);
                                }
                                self.facets = SetFacets(self.facets, res.data['@search.facets'], self.initialSearch, self.checkedFacets, self.facetOptions);
                                self.count = res.data['@odata.count'];
                                self.noResults = self.count <= 0;

                                if (self.count > 0) {
                                    if (self.facetValueOverrides) {
                                        self.setFacetValueOverrides(self.facetValueOverrides);
                                    }

                                    if (self.initialSearch && !self.noResults) {
                                        self.initialSearch = false;
                                    }
                                    resolve();
                                }
                                else resolve('NO_PRODUCTS');
                            }
                            else resolve('EMPTY_RESPONSE');
                        })
                        .catch((err) => {
                            console.error(err);
                            self.hasError = true;
                            reject(err);
                        });
                });
            },
            facetClicked(val) {
                this.filtered = true;
                return false;
            },
            getDocumentUrl(item) {
                const documentCulture = item.documentculture.toLowerCase() === 'en-zw' || item.documentculture.toLowerCase() === 'es-ve'
                    ? item.documentculture.split('-')[0]
                    : item.documentculture;
                if (item.documenturlpath) return `/${documentCulture}${item.documenturlpath}/`.toLowerCase();
                return '';
            },
            getTeaserImage(teaserimage) {
                if (teaserimage) return teaserimage.replace('~', '');
                else return '/Images/no_image.svg';
            },
            gotoPage(page) {
                this.currentPage = page;
                this.search();
            },
            nextPage() {
                this.currentPage++;
                this.search();
            },
            previousPage() {
                this.currentPage--;
                this.search();
            },
            saveBeforeRedirect() {
                this.saveSettingsToLocalStorage();
                history.replaceState(null, null, CreateQueryString(true));
            },
            saveSettingsToLocalStorage() {
                let storeObject = { checkedFacets: this.checkedFacets, currentPage: this.currentPage };
                let storeJSON = JSON.stringify(storeObject);
                window.localStorage.setItem(this.localStorageName, storeJSON);
            },
            search(event) {
                if (event) event.preventDefault();
                const self = this;

                return new Promise((resolve, reject) => {
                    const preFilter = GetPreFilter();
                    history.replaceState(null, null, CreateQueryString());
                    self.hasError = false;

                    let searchRequest = self.createSearchRequest();
                    self.executeSearch(searchRequest)
                        .then((res) => {
                            if (preFilter) this.checkedFacets.push(preFilter);
                            resolve();
                        })
                        .catch(reject);
                });
            },
            setFacetValueOverrides(overrides) {
                let facet, foundFacetValue;
                for (let key in overrides) {
                    facet = this.facets[key];
                    if (facet) {
                        overrides[key].forEach((value) => {
                            foundFacetValue = _.find(facet, (x) => x.value.trim() === value.key);
                            if (foundFacetValue) {
                                foundFacetValue['displayValue'] = value.value;
                            }
                        });
                    }
                }
            },
            toggleCollapse(event) {
                if (event) event.preventDefault();
                const triggers = [].slice.call(document.querySelectorAll('[data-toggle="collapse"]'));
                const elm = event.target;

                if (_.includes(triggers, elm)) {
                    const fnmap = {
                        'toggle': 'toggle',
                        'show': 'add',
                        'hide': 'remove'
                    };

                    const selector = elm.getAttribute('data-target');
                    const targets = [].slice.call(document.querySelectorAll(selector));
                    targets.forEach(target => {
                        target.classList[fnmap['toggle']]('show');
                    });
                    elm.classList.toggle('collapsed');
                }
            }
        },
        created() {
            const searchSettingsElId = 'search-settings';
            const facetSettingsElId = 'facet-settings';
            const facetOptionsElId = 'facet-options';
            const seoSettingsElId = 'seo-settings';
            const ctaSettingsElId = 'cta-settings';

            const searchSettingsEl = document.getElementById(searchSettingsElId);
            const facetSettingsEl = document.getElementById(facetSettingsElId);
            const facetOptionsEl = document.getElementById(facetOptionsElId);
            const seoSettingsEl = document.getElementById(seoSettingsElId);
            const ctaSettingsEl = document.getElementById(ctaSettingsElId);

            if (facetSettingsEl && facetOptionsEl && searchSettingsEl) {
                this.searchSettings = JSON.parse(searchSettingsEl.innerHTML);
                this.facetSettings = JSON.parse(facetSettingsEl.innerHTML);
                this.facetOptions = JSON.parse(facetOptionsEl.innerHTML);
                if (seoSettingsEl) this.seoSettings = JSON.parse(seoSettingsEl.innerHTML);
                if (ctaSettingsEl) this.ctaSettings = JSON.parse(ctaSettingsEl.innerHTML);

                // Check if mandatory setting objects are not just empty
                if (!_.isEmpty(this.searchSettings) && !_.isEmpty(this.facetSettings)) {
                    this.searchText = this.searchSettings.searchRequest.search;
                    this.currentPage = this.searchSettings.gui.page;

                    if (!this.searchSettings.searchRequest.orderBy) this.searchSettings.searchRequest.orderBy = 'name asc';

                    this.searchApi = new azureSearch.AzureSearchApi(this.searchSettings);

                    this.searchSettings.facets.forEach((facet) => {
                        if (facet && facet.facetValueOverrides) {
                            // Set facet-value-overrides coming from the system
                            this.facetValueOverrides[facet.field] = facet.facetValueOverrides;

                            // Set one extra override, this handles the 'empty' field stuff
                            this.facetValueOverrides[facet.field].push({ key: '', value: '(onbekend)' });
                        }
                        else if (facet) {
                            // Set at least one override for all fields to handle 'empty' values
                            this.facetValueOverrides[facet.field] = [{ key: '', value: '(onbekend)' }];
                        }
                    });

                    let rfsQueryParam = helper.getParameterByName('action');
                    if (rfsQueryParam === 'rfs') {
                        let localStorageJSON = window.localStorage.getItem(this.localStorageName);
                        if (localStorageJSON) {
                            let storedObject = JSON.parse(localStorageJSON);

                            this.restoreFromStorage = true;

                            this.tempRestorePage = storedObject.currentPage;
                            this.currentPage = storedObject.currentPage;
                            this.checkedFacets = storedObject.checkedFacets;

                            window.localStorage.removeItem(this.localStorageName);
                        }
                    }

                    if (this.searchSettings.gui.executeSearchOnLoad && !this.restoreFromStorage) {
                        this.search()
                            .then((res) => {
                                this.ready = true;
                            })
                            .catch((err) => {
                                this.ready = true;
                                console.error(err);
                            });
                    } else if (!this.restoreFromStorage) {
                        this.ready = true;
                    }
                }
                else console.log('missing required settings');
            } else console.log('missing required settings');
        }
    });
}

function CreateQueryString(restoreFromStorage) {
    let result = window.location.pathname;
    if (restoreFromStorage === true) result += '?action=rfs';
    return result;
}

function ConcatFilters(filterArgs) {
    if (filterArgs) {
        let filters;
        for (let i = 0; i < filterArgs.length; i++) {
            if (filterArgs[i] && filterArgs[i] !== '') {
                if (filters) {
                    filters = (filters + 'and' + filterArgs[i]);
                } else {
                    filters = filterArgs[i];
                }
            }
        }
        return filters;
    }
    return null;
}

function GetFacetFilter(items, facetSettings) {
    let filter = '';
    let facets = items.map((item) => {
        let kv = item.split('|');
        let facet = _.find(facetSettings, (facet) => facet.key === kv[0]);
        return { facetKey: kv[0], facetValue: kv[1], facetType: facet.value };
    });

    let groupedFacets = _.groupBy(facets, 'facetKey');
    _.forEach(groupedFacets, (key) => {
        var subFilter = '';
        key.forEach((facet) => {
            if (facet.facetType === 'Collection') {
                subFilter += facet.facetKey + '/any(t: t eq \'' + facet.facetValue + '\') or ';
            }
            else if (facet.facetType === 'String') {
                subFilter += facet.facetKey + ' eq \'' + facet.facetValue + '\' or ';
            }
            else {
                subFilter += facet.facetKey + ' eq ' + facet.facetValue + ' or ';
            }
        });

        subFilter = `(${stripLastAndOr(subFilter)})`;
        filter += subFilter + ' and ';
    });

    return stripLastAndOr(filter);
}

function SetFacets(currentFacets, newFacets, initialSearch, checkedFacets, facetOptions) {
    for (var key in newFacets) {
        // Entire facets or facet options from Azure search which are not in facet options are removed
        if (!facetOptions.hasOwnProperty(key)) {
            delete newFacets[key];
        } else {
            newFacets[key] = _.filter(newFacets[key],
                x => _.includes(facetOptions[key], x.value));
        }

        // Guard checks
        if (initialSearch) continue;

        if (newFacets.hasOwnProperty(key) && key.indexOf('@odata') === -1) {
            // Get the items that are not in the new facet result and set the count to zero
            var difference = _.differenceBy(currentFacets[key], newFacets[key], 'value');
            if (difference && difference.length > 0) {
                difference.forEach(function (diff) {
                    if (!doHasASelectedFacetValue(key, checkedFacets)) diff.count = 0;
                });
            }

            // Get all items that still are in the new facet results and set them to their new count
            var intersect = _.intersectionBy(newFacets[key], currentFacets[key], 'value');
            if (intersect && intersect.length > 0) {
                intersect.forEach(function (inter) {
                    var item = _.find(currentFacets[key], function (x) { return x.value === inter.value; });
                    if (item) item.count = inter.count;
                });
            }
        }
    }

    // Guard checks
    if (initialSearch) return newFacets;

    return currentFacets;
}

function GetPreFilter() {
    return helper.getParameterByName('prefilter');
}

function stripLastAndOr(filter) {
    var tmp = filter + '';
    var reAnd = /and$/;
    var reOr = /or$/;

    tmp = tmp.trimEnd();
    tmp = tmp.replace(reAnd, '');
    tmp = tmp.replace(reOr, '');

    return tmp;
}

function doHasASelectedFacetValue(facetKey, checkedFacets) {
    if (checkedFacets !== null && checkedFacets.length > 0) {
        if (checkedFacets.findIndex(function (f) { return f.startsWith(facetKey); }) > -1) {
            return true;
        }
    }
    return false;
}

export default {
    init
};
